// Select — dropdown select over MUI TextField (select mode) for consistent
// label/error/helper behavior with TextField. Options are [{value,label}].
import PropTypes from 'prop-types';
import MuiTextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

export function Select({
  label,
  value,
  onChange,
  onBlur,
  options = [],
  error,
  helperText,
  required = false,
  fullWidth = true,
  disabled = false,
  placeholder,
  ...rest
}) {
  return (
    <MuiTextField
      select
      label={label}
      value={value ?? ''}
      onChange={onChange}
      onBlur={onBlur}
      error={!!error}
      helperText={error || helperText}
      required={required}
      fullWidth={fullWidth}
      disabled={disabled}
      size="small"
      variant="outlined"
      {...rest}
    >
      {placeholder && (
        <MenuItem value="" disabled>
          {placeholder}
        </MenuItem>
      )}
      {options.map((opt) => (
        <MenuItem key={opt.value} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))}
    </MuiTextField>
  );
}

Select.propTypes = {
  label: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.node.isRequired,
    }),
  ),
  error: PropTypes.node,
  helperText: PropTypes.node,
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
};

export default Select;
